import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "./MerchandiseOrdersDashboard.css";
import { Spinner } from "@xola/ui-kit";
import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import React, { useRef } from "react";
import { getRowHeight } from "../DashboardTable/gridUtils";
import { MerchandiseDashboardFilters } from "./MerchandiseDashboardFilters";
import { useMerchandiseOrdersData } from "./useMerchandiseOrdersData";

const defaultColDef: ColDef = {
    sortable: true,
    resizable: false,
    filter: false,
    suppressAutoSize: true,
    flex: 1,
};

const rowClassRules = {
    "merchandise-row": () => {
        return true;
    },
};

export const MerchandiseOrdersDashboard = () => {
    const gridRef = useRef<AgGridReact>(null);

    const { rowData, columnDefs, isLoading, hasNoData } = useMerchandiseOrdersData();

    return (
        <div className="flex h-full flex-col" id="merchandise-dashboard">
            <MerchandiseDashboardFilters />

            {isLoading ? (
                <div className="flex h-full items-center justify-center">
                    <Spinner />
                </div>
            ) : hasNoData ? (
                <div className="flex h-full flex-col items-center justify-center">
                    <span className="text-lg font-bold text-black">No merchandise orders found</span>
                    <span className="text-gray-dark">Try adjusting your filters or date range</span>
                </div>
            ) : (
                <div className="ag-theme-alpine merchandise-dashboard-list h-full px-2 pt-4">
                    <AgGridReact
                        ref={gridRef}
                        suppressCellFocus
                        suppressContextMenu
                        suppressNoRowsOverlay
                        tooltipMouseTrack
                        suppressScrollOnNewData
                        suppressRowHoverHighlight={false}
                        animateRows={false}
                        suppressAnimationFrame={false}
                        theme="legacy"
                        domLayout="normal"
                        rowBuffer={15}
                        defaultColDef={defaultColDef}
                        rowClassRules={rowClassRules}
                        getRowHeight={getRowHeight}
                        rowData={rowData}
                        columnDefs={columnDefs}
                        rowSelection="single"
                        tooltipShowDelay={0}
                    />
                </div>
            )}
        </div>
    );
};
